import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets.app/images/warren_buffet_exp_cancel_save_flow.png'


const _hoisted_1 = { class: "cancel-flow-popup__footer" }

import { onMounted } from 'vue'

import AppButton from '@/app/components/button/AppButton.vue'
import { BillingView } from '@/models/billing'
import { Mixpanel } from '@/analytics/mixpanel'


export default /*@__PURE__*/_defineComponent({
  __name: 'CancelFlowIntro',
  props: {
    billing: {},
    loading: { type: Boolean }
  },
  emits: ["keep", "continue"],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emit = __emit

onMounted(() => {
  Mixpanel.trackCancelFlowStepShown(props.billing, 'intro')
})

function onKeep(): void {
  Mixpanel.trackCancelFlowButtonClick(props.billing, 'intro', 'keep')
  emit('keep')
}

function onContinue(): void {
  Mixpanel.trackCancelFlowButtonClick(props.billing, 'intro', 'continue')
  emit('continue')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "cancel-flow-intro" }, [
      _createElementVNode("p", null, " Shortform helps you learn more in less time. Do you value your personal growth at more than $1 per hour? If so, keeping Shortform might be worth it. "),
      _createElementVNode("div", { class: "cancel-flow-intro__divider" }),
      _createElementVNode("img", {
        class: "cancel-flow-intro__image",
        src: _imports_0,
        width: "360",
        height: "254",
        alt: ""
      }),
      _createElementVNode("p", null, [
        _createTextVNode(" We're inspired by Warren Buffett, who said: "),
        _createElementVNode("strong", null, " \"The best investment you can make is an investment in yourself. The more you learn, the more you'll earn.\" ")
      ])
    ], -1)),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(AppButton, {
        disabled: __props.loading,
        class: "cancel-flow-popup__cta",
        onClick: onKeep
      }, {
        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
          _createTextVNode(" Keep my personal growth ", -1)
        ]))]),
        _: 1
      }, 8, ["disabled"]),
      _createVNode(AppButton, {
        danger: true,
        loading: __props.loading,
        disabled: __props.loading,
        class: "cancel-flow-popup__cta",
        onClick: onContinue
      }, {
        default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
          _createTextVNode(" End my personal growth ", -1)
        ]))]),
        _: 1
      }, 8, ["loading", "disabled"])
    ])
  ], 64))
}
}

})